import { useEffect, useState } from "react";
import { BsInfoCircle } from "react-icons/bs"
import { FiUpload } from "react-icons/fi"
import BackComponent from "../../../../components/BackArrow";
import { useParams } from "react-router-dom";
import WebService from "../../../../utility/WebService";
import { useForm } from "react-hook-form";
import { Label } from "../../../../components/Label/Label";
import SucessModal from "../../../../components/SucessModal/Sucess"; 
import WarningModal from "../../../../components/Warning/Warning";
import loader from "../../../../assets/images/button-loader.svg"

const AgreementUploadDocument = () => {
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        formState: { errors },
    } = useForm();
    let { id } = useParams();
    const watchAllFields = watch();
    const [isLoading, setLoading] = useState(false);
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [image, setImage] = useState<any>({});
    const [documentName, setDocumentName] = useState('');
    const user_data = JSON.parse(localStorage.getItem("user_Detail") || "{}");

    useEffect(() => {
    }, []);

    const onSave = () => {
        if(user_data.is_person == 'Client'){
            let fileName = image.name;
        let extension = fileName.split(".").pop();
        if (extension == "png" || extension == "jpg" || extension == "jpeg") {
        var form = new FormData();
        if (id) {
            form.append('id', id);
        }
        if (image) {
            form.append('ClientAgreements[signature_document]', image);
        }
        setLoading(true);
        WebService.fileUploadAPI({
            action: `/v2/ClientAgreements/AddSignature`,
            body: form,
        })
            .then((res: any) => {
                setShowSucessModal(true);
                setSucessMessage(res.message)
                goBack();
            })
            .catch((e) => {
                setShowWarningModal(true);
                setWarningMessage(e.response.data.message)
                setLoading(false);
            });
        }
        else{
            setShowWarningModal(true);
                setWarningMessage("File type must be Image.")
        }
        }
        else if(user_data.is_person == 'Employee'){
            let fileName = image.name;
            let extension = fileName.split(".").pop();
            if (extension == "pdf") {
            var form = new FormData();
            if (id) {
                form.append('id', id);
            }
            if (image) {
                form.append('ClientAgreements[final_agreement]', image);
            }
            setLoading(true);
            WebService.fileUploadAPI({
                action: `/v2/ClientAgreements/UploadDocument`,
                body: form,
            })
                .then((res: any) => {
                    setShowSucessModal(true);
                    setSucessMessage(res.message)
                    goBack();
                })
                .catch((e) => {
                    setShowWarningModal(true);
                    setWarningMessage(e.response.data.message)
                    setLoading(false);      
                });
            }
            else{
                setShowWarningModal(true);
                    setWarningMessage("File type must be PDF.")
            }
        }
       
    };

    const goBack = () => {
        window.history.back();
    };

    const onLoadImage = (event: any) => {
        const { files } = event.target;
        if (files && files[0]) {
            setDocumentName(files[0].name);
            setValue("document_name", files[0].name)
            setImage(files[0])
        }
        event.target.value = '';
    };

    const warningCloseModal = () => {
        setShowWarningModal(false)
        setLoading(false);
    };

    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setLoading(false);
    }

    return (
        <>
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />
            <div className="page-content-wraper">
                <form onSubmit={handleSubmit(onSave)}>
                    <div className="grid grid-cols-2 gap-4 mb-3">
                        <div> <BackComponent title={'Upload Agreement Document'} /></div>
                    </div>
                    <div className="rounded-xl bg-white p-4 mb-4">
                        <div className=" grid grid-cols-3 gap-4 form-style">
                            <div className="col-span-3">
                                <div className="mb-2 display-none" >
                                    <label className="label">
                                        First Name<span className=" text-red-600">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="dummy_input"
                                        className="form-control"
                                        {...register("document_name", {
                                            required: true,
                                        })}
                                    />
                                </div>
                                {user_data.is_person == 'Client' ? 
                                <label className="label">Upload Signature <span className=" text-red-600">*</span></label>
                                : <label className="label">Upload Signed Document <span className=" text-red-600">*</span></label>
                            }
                                <div className="flex w-70" >
                                    <label className="block flex justify-center bg-brand rounded-md py-1 text-sm items-center cursor-pointer hover:bg-violet-600">
                                        <span className=" absolute text-white">
                                            <FiUpload className="mr-1 inline" size={20} />
                                            {user_data.is_person == 'Client' ? "Upload Signature" : " Upload Document"}</span>
                                        <input type="file" className="block w-40 text-sm text-slate-500  opacity-0" title=""
                                            onChange={(e: any) => {
                                                onLoadImage(e)
                                            }
                                            }
                                        />
                                    </label>
                                    <BsInfoCircle className="ml-4 mt-2 cursor-pointer" title="Valid file types are doc,docx,pdf,bmp,jpg,jpeg,gif,png,ppt,pptx,xls,xlsx,txt. Max size of each file is 2MB" />
                                </div>
                                <div >
                                        {!watchAllFields.document_name && errors.document_name && (
                                            <Label
                                                title={user_data.is_person == 'Client' ? "Please Upload Signature" : "Please Upload Document" }
                                                modeError={true}
                                            />
                                        )}
                                    </div>
                                {documentName}
                            </div>
                        </div>
                    </div>
                    <div className="text-center mt-4">
                        <button type="button" className="btn btn-white mr-3" onClick={goBack}>Cancel</button>
                        <button type="submit" className="btn btn-brand">
                            {isLoading && <img src={loader} className='spinner' />}Save</button>
                    </div>
                </form>
            </div>
        </>
    )
}
export default AgreementUploadDocument;